<template>
    <div class="preregistro">
        <v-container>
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_aceptar" max-width="290">
                <v-card>
                    <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                    <v-card-text>Para continuar es necesario Aceptar los <strong>Términos y Condiciones</strong>.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog_aceptar = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_cellphone" max-width="290">
                <v-card>
                    <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                    <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_condiciones" persistent width="600px">
                <v-card align="justify">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            Intrare
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-flex xs12>
                            <v-img
                                    class="centrado ml-4 mr-4"
                                    :src="require('../assets/intLogo.png')"
                                    height="250px"
                                    contain
                            ></v-img>
                        </v-flex>
                        <br>
                        <div><h2>Términos y Condiciones</h2></div>
                        <br>
                        <div class="body-2">
                            El presente documento establece las condiciones mediante las cuales se regirá el uso del
                            sistema y/o aplicación: INTRARE (en adelante el sistema), el cual es operado por
                            TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. empresa constituida en
                            México y domiciliada en la ciudad de San Luis Potosí, S.L.P. y que en adelante se
                            identificara por su nombre comercial “INTRARE”
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE es un sistema digital de acceso que facilita la identificación y agiliza el proceso
                            de ingreso de visitantes, proveedores, empleados y trabajadores domésticos a diversos
                            polígonos, dejando un registro de fecha y hora de salida.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE cuenta con submarcas que a su vez encuadran áreas específicas en las que se
                            aplicaran los servicios del sistema, por lo que el usuario podrá encontrarse con las
                            siguientes denominaciones dentro del sistema: a) Intrare Residencia, b)Intrare Empresa,
                            c)Intrare Construcción, d)Intrare Escuela.
                        </div>
                        <br>
                        <div class="body-2">
                            El usuario se compromete a leer los términos y condiciones aquí establecidas, previamente
                            al uso del sistema, por tanto, en caso de realizar la instalación se entiende que cuenta con
                            el conocimiento integral de este documento y la consecuente aceptación de la totalidad de
                            sus estipulaciones.
                        </div>
                        <br>
                        <div class="body-2">
                            El Usuario reconoce que el ingreso de su información personal y los datos que contiene el
                            sistema a su disposición lo realizan de manera voluntaria, quienes optan por acceder a este
                            sistema en México o desde fuera del territorio nacional, lo hacen por iniciativa propia y son
                            responsables del cumplimiento de las leyes locales, en la medida en que dichas leyes sean
                            aplicables en su correspondiente país. En caso de que se acceda por parte de menores de
                            edad, deben contar con la supervisión de un adulto en todo momento desde la instalación
                            y durante el uso del sistema, en el evento en que no se cumpla esta condición, le
                            agradecemos no hacer uso del sistema.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Alcance y Uso</strong></div>
                        <br>
                        <div class="body-2">
                            El usuario del sistema entiende y acepta que es operado por TECNOLOGÍAS EN
                            ACCESOS CONTROLADOS SA DE CV., la información contenida en el mismo será la
                            referente a su vínculo comercial o contractual con la empresa.
                        </div>
                        <br>
                        <div class="body-2">
                            Los tiempos de respuesta, tramites y demás solicitudes efectuadas por el usuario mediante
                            el sistema serán procesadas de conformidad con las especificaciones de cada producto
                            activo con INTRARE.
                        </div>
                        <br>
                        <div class="body-2">
                            El usuario acepta y autoriza que los registros electrónicos de las actividades mencionadas,
                            que realice en el sistema constituyen plena prueba de los mismos.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Requisitos para Uso</strong></div>
                        <br>
                        <div class="body-2">
                            El usuario deberá contar con un dispositivo móvil inteligente (Smartphone) o Tableta con
                            sistema operativo Android o IOS o un ordenador, cualquiera de estos con acceso a internet,
                            ambos seguros y confiables. INTRARE, no será responsable por la seguridad de los
                            equipos Smartphone propiedad de los usuarios utilizados para el acceso al sistema, ni por
                            la disponibilidad del servicio en los dispositivos en los cuales se descargue el sistema.
                        </div>
                        <br>
                        <div class="body-2">
                            En la forma permitida por la ley, los materiales del sistema se suministran sin garantía de
                            ningún género, expresa o implícitamente, incluyendo sin limitación las garantías de calidad
                            satisfactoria, comerciabilidad, adecuación para un fin particular o no infracción, por tanto,
                            INTRARE no garantiza el funcionamiento adecuado en los distintos sistemas operativos o
                            dispositivos en los cuales se haga uso del sistema.
                        </div>
                        <br>
                        <div class="body-2">
                            Para acceder al portal, EL CLIENTE contará con Usuario y Clave, que lo identifica en su
                            relación con INTRARE. Adicional a lo anterior se requerirá a EL CLIENTE, al momento de
                            acceder al sistema que ingrese su nombre de usuario y contraseña.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Obligaciones de los Usuarios</strong></div>
                        <br>
                        <div class="body-2">
                            El Usuario se obliga a usar el sistema y los contenidos encontrados en ella de una manera
                            diligente, correcta, lícita y en especial, se compromete a NO realizar las conductas descritas
                            a continuación:
                        </div>
                        <br>
                        <div class="body-2">
                            (a) Utilizar los contenidos de forma, con fines o efectos contrarios a la ley, a la moral y a las
                            buenas costumbres generalmente aceptadas o al orden público;
                        </div>
                        <br>
                        <div class="body-2">
                            (b) Reproducir, copiar, representar, utilizar, distribuir, transformar o modificar los contenidos
                            del sistema, por cualquier procedimiento o sobre cualquier soporte, total o parcial, o permitir
                            el acceso del público a través de cualquier modalidad de comunicación pública;
                        </div>
                        <br>
                        <div class="body-2">
                            (c) Utilizar los contenidos de cualquier manera que entrañen un riesgo de daño o
                            inutilización del sistema o de los contenidos o de terceros;
                        </div>
                        <br>
                        <div class="body-2">
                            (d) Suprimir, eludir o manipular el derecho de autor y demás datos identificativos de los
                            derechos de autor incorporados a los contenidos, así como los dispositivos técnicos de
                            protección, o cualesquiera mecanismos de información que pudieren tener los contenidos;
                        </div>
                        <br>
                        <div class="body-2">
                            (e) Emplear los contenidos y, en particular, la información de cualquier clase obtenida a
                            través de del sistema para distribuir, transmitir, remitir, modificar, rehusar o reportar la
                            publicidad o los contenidos de esta con fines de venta directa o con cualquier otra clase de
                            finalidad comercial, mensajes no solicitados dirigidos a una pluralidad de personas con
                            independencia de su finalidad, así como comercializar o divulgar de cualquier modo dicha
                            información;
                        </div>
                        <br>
                        <div class="body-2">
                            (f) No permitir que terceros ajenos a usted usen el sistema con su clave;
                        </div>
                        <br>
                        <div class="body-2">
                            (g) Utilizar el sistema y los contenidos con fines lícitos y/o ilícitos, contrarios a lo establecido
                            en estos Términos y Condiciones, o al uso mismo del sistema, que sean lesivos de los
                            derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar,
                            sobrecargar o deteriorar el sistema y los contenidos o impedir la normal utilización o disfrute
                            de esta y de los contenidos por parte de los usuarios.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Propiedad Intelectual</strong></div>
                        <br>
                        <div class="body-2">
                            Todo el material informático, gráfico, publicitario, fotográfico, de multimedia, audiovisual y
                            de diseño, así como todos los contenidos, textos y bases de datos puestos a su disposición
                            en este sistema están protegidos por derechos de autor y/o propiedad industrial cuyo titular
                            es TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. Igualmente, el uso en el
                            sistema de algunos materiales de propiedad de terceros se encuentra expresamente
                            autorizado por la ley o por dichos terceros. Todos los contenidos en el sistema están
                            protegidos por las normas sobre derecho de autor y por todas las normas nacionales e
                            internacionales que le sean aplicables.
                        </div>
                        <br>
                        <div class="body-2">
                            Exceptuando lo expresamente estipulado en estos Términos y Condiciones, queda
                            prohibido todo acto de copia, reproducción, modificación, creación de trabajos derivados,
                            venta o distribución, exhibición de los contenidos de este sistema, de manera o por medio
                            alguno, incluyendo, más no limitado a, medios electrónicos, mecánicos, de fotocopiado, de
                            grabación o de cualquier otra índole, sin el permiso previo y por escrito de INTRARE o del
                            titular de los respectivos derechos.
                        </div>
                        <br>
                        <div class="body-2">
                            En ningún caso estos Términos y Condiciones confieren derechos, licencias ni
                            autorizaciones para realizar los actos anteriormente prohibidos. Cualquier uso no
                            autorizado de los contenidos constituirá una violación del presente documento y a las
                            normas vigentes sobre derechos de autor, a las normas vigentes nacionales e
                            internacionales sobre Propiedad Industrial, y a cualquier otra que sea aplicable.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Licencia para Copiar para Uso Personal</strong></div>
                        <br>
                        <div class="body-2">
                            Usted podrá leer, visualizar, imprimir y descargar el material que integra el sistema.
                        </div>
                        <br>
                        <div class="body-2">
                            Ninguna parte del sistema podrá ser reproducida o transmitida o almacenada en otro sitio
                            web o en otra forma de sistema de recuperación electrónico.
                        </div>
                        <br>
                        <div class="body-2">
                            Ya sea que se reconozca específicamente o no, las marcas comerciales, las marcas de
                            servicio y los logos visualizados en este sistema pertenecen a TECNOLOGÍAS EN
                            ACCESOS CONTROLADOS S.A. DE C.V., sus socios promocionales u otros terceros.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE no interfiere, no toma decisiones, ni garantiza las relaciones que los usuarios
                            lleguen a sostener o las vinculaciones con terceros que pauten y/o promocionen sus
                            productos y servicios. Estas marcas de terceros se utilizan solamente para identificar los
                            productos y servicios de sus respectivos propietarios y el patrocinio o el aval por parte de
                            INTRARE no se deben inferir con el uso de estas marcas comerciales.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Integración con Otras Aplicaciones</strong></div>
                        <br>
                        <div class="body-2">
                            INTRARE podrá enlazarse por medio de links con otras aplicaciones como por ejemplo
                            Facebook, Google, Gmail, One Drive , etc. Lo anterior con el fin de poder sincronizar
                            calendarios y wallets.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE trata de suministrar enlaces a sitios y aplicaciones de terceros que cumplan con
                            las leyes y regulaciones aplicables y las normas de INTRARE, el Usuario debe entender
                            que INTRARE no tiene control sobre la naturaleza y el contenido de esos sitios y no está
                            recomendando estos sitios, la información que contienen ni los productos o servicios de
                            terceros.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE no acepta responsabilidad por el contenido del sitio de un tercero con el cual
                            existe un link de hipertexto y no ofrece garantía (explícita o implícita) en cuanto al contenido
                            de la información en esos sitios, ya que no recomienda estos sitios.
                        </div>
                        <br>
                        <div class="body-2">
                            Usted debe verificar las secciones de términos y condiciones, política legal y de privacidad
                            de algunos otros sitios que con los cuales INTRARE se enlaza.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE no asume ninguna responsabilidad por pérdida directa, indirecta o consecuencial
                            por el uso de un sitio de un tercero.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Uso de Información y Privacidad</strong></div>
                        <br>
                        <div class="body-2">
                            Con la descarga del sistema usted acepta y autoriza que TECNOLOGÍAS EN ACCESOS
                            CONTROLADOS S.A. DE C.V., utilice sus datos en calidad de responsable del tratamiento
                            para fines derivados de la ejecución del sistema. TECNOLOGÍAS EN ACCESOS
                            CONTROLADOS S.A. DE C.V. informa que podrá ejercer sus derechos a conocer,
                            actualizar, rectificar y suprimir su información personal; así como el derecho a revocar el
                            consentimiento otorgado para el tratamiento de datos personales previstos en la ley,
                            observando nuestro Aviso de Privacidad mismo que se establece en nuestra página
                            www.intrare.com.mx ; o a través de holas@intrare.app.
                        </div>
                        <br>
                        <div class="body-2">
                            TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. podrá dar a conocer,
                            transferir y/o trasmitir sus datos personales dentro y fuera del país a terceros a
                            consecuencia de un contrato, ley o vínculo lícito que así lo requiera, para todo lo anterior
                            otorgo mi autorización expresa e inequívoca.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Responsabilidad de INTRARE</strong></div>
                        <br>
                        <div class="body-2">
                            INTRARE procurará garantizar disponibilidad, continuidad o buen funcionamiento del
                            sistema. INTRARE podrá bloquear, interrumpir o restringir el acceso a esta cuando lo
                            considere necesario para el mejoramiento del sistema o por dada de baja de la misma.
                        </div>
                        <br>
                        <div class="body-2">
                            Se recomienda al Usuario tomar medidas adecuadas y actuar diligentemente al momento
                            de acceder al sistema, como, por ejemplo, contar con programas de protección, antivirus,
                            para manejo de malware, spyware y herramientas similares.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE no será responsable por: a) Fuerza mayor o caso fortuito; b) Por la pérdida,
                            extravío o hurto de su dispositivo móvil u ordenador que implique el acceso de terceros a al
                            sistema; c) Por errores en la digitación o accesos por parte del cliente; d) Por los perjuicios,
                            lucro cesante, daño emergente, morales, y en general sumas a cargo de INTRARE,
                            derivados de los retrasos, no procesamiento de información o suspensión del servicio del
                            operador móvil o daños en los dispositivos móviles.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Pagos</strong></div>
                        <br>
                        <div class="body-2">
                            INTRARE no recibe ni gestiona pagos por medio del sistema. Todo lo relacionado a
                            contratación y pagos se maneja de forma externa entre TECNOLOGÍAS EN ACCESOS
                            CONTROLADOS S.A. DE C.V. y el Cliente por otros medios.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Denegación y Retirada del Acceso al Sistema</strong></div>
                        <br>
                        <div class="body-2">
                            En el Evento en que un Usuario incumpla estos Términos y Condiciones, o cualesquiera
                            otras disposiciones que resulten de aplicación, INTRARE podrá suspender su acceso al
                            sistema.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Términos y Condiciones</strong></div>
                        <br>
                        <div class="body-2">
                            El Usuario acepta expresamente los Términos y Condiciones, siendo condición esencial
                            para la utilización de este sistema. En el caso en que se encuentre en desacuerdo con estos
                            Términos y Condiciones, solicitamos abandonar el sistema inmediatamente. INTRARE
                            podrá modificar los presentes términos y condiciones, avisando a los usuarios del sistema
                            mediante publicación en la página web www.intrare.com.mx o mediante la difusión de las
                            modificaciones por algún medio electrónico, redes sociales, SMS y/o correo electrónico, lo
                            cual se entenderá aceptado por el usuario si éste continua con el uso del sistema.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Jurisdicción</strong></div>
                        <br>
                        <div class="body-2">
                            Estos términos y condiciones y todo lo que tenga que ver con este sistema, se rigen por las
                            leyes Mexicanas y los Tratados Internacionales de los que forma parte México. Para
                            cualquier solución de conflictos que pudieran resultar del uso del sistema, las partes se
                            someten a la jurisdicción de los tribunales de la Ciudad de San Luis Potosí, S.L.P.,
                            renunciando a cualquiera otra que por domicilio les corresponda.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Uso de Información no Personal</strong></div>
                        <br>
                        <div class="body-2">
                            INTRARE también recolecta información no personal en forma agregada para seguimiento
                            de datos como el número total de accesos al sistema, instalación, descarga, etc. Utilizamos
                            esta información, que permanece en forma agregada, para entender el comportamiento del
                            sistema y poder mejorar el servicio del mismo.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Uso de Direcciones IP</strong></div>
                        <br>
                        <div class="body-2">
                            Una dirección de Protocolo de Internet (IP) es un conjunto de números que se asigna
                            automáticamente a su o dispositivo móvil u ordenador cuando usted accede a su proveedor
                            de servicios de internet, o a través de la red de área local (LAN) de su organización o la red
                            de área amplia (WAN). Los servidores web automáticamente identifican su dispositivo móvil
                            u ordenador por la dirección IP asignada a él durante su sesión en línea.
                        </div>
                        <br>
                        <div class="body-2">
                            INTRARE podrán recolectar direcciones IP para propósitos de administración de sistemas
                            y para auditar el uso de nuestro sistema, todo lo anterior de acuerdo con la autorización de
                            protección de datos que se suscribe para tal efecto. Normalmente no vinculamos la
                            dirección IP de un usuario con la información personal de ese usuario, lo que significa que
                            cada sesión de usuario se registra, pero el usuario sigue siendo anónimo para nosotros.
                            Sin embargo, podemos usar las direcciones IP para identificar a los usuarios de nuestro
                            sistema cuando sea necesario con el objeto de exigir el cumplimiento de los términos de
                            uso del sistema, o para proteger nuestro servicio, sitio u otros usuarios.
                        </div>
                        <br>
                        <div class="subtitle-1"><strong>Seguridad</strong></div>
                        <br>
                        <div class="body-2">
                            INTRARE está comprometido en la protección de la seguridad de su información personal.
                            INTRARE tiene implementados mecanismos de seguridad que aseguran la protección de
                            la información personal, así como los accesos únicamente al personal y sistemas
                            autorizados, también contra la pérdida, uso indebido y alteración de sus datos de usuario
                            bajo nuestro control.
                        </div>
                        <br>
                        <div class="body-2">
                            Excepto como se indica a continuación, sólo personal autorizado tiene acceso a la
                            información que nos proporciona. Además, hemos impuesto reglas estrictas a los
                            empleados de INTRARE con acceso a las bases de datos que almacenan información del
                            usuario o a los servidores que hospedan nuestros servicios.
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="dialog_condiciones = false">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneFrenteURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog = false, get_image_recortada()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog3" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                ref="clipper3"
                                :rotate="degrees"
                                :ratio="ratio"
                                :src="imageIneAtrasURL">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions  class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-radio-group
                                        v-model="ratio"
                                        name="ratio"
                                        row
                                        label="Ratio"
                                        :mandatory="false"
                                >
                                    <v-radio label="1:1" :value="1"></v-radio>
                                    <v-radio label="3:2" :value="1.5"></v-radio>
                                    <v-radio label="4:3" :value="1.3333333333333333"></v-radio>
                                    <v-radio label="16:9" :value="1.7777777777777777"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog3 = false, get_image_recortada3()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog2" persistent scrollable max-width="700px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-fixed
                                class="basic lg"
                                :src="imageFotoFrenteURL"
                                ref="clipper2"
                                :rotate="degrees"
                                :round="true"
                                preview="preview">
                        </clipper-fixed>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap class="justify-center">
                            <v-flex xs12>
                                <v-slider
                                        v-model="degrees"
                                        :label="$t('grados')"
                                        step="1"
                                        max="180"
                                        min="-180"
                                        thumb-label="always"
                                ></v-slider>
                            </v-flex>
                            <v-btn
                                    color="primary"
                                    @click="dialog2 = false, get_image_recortada2()"
                            >{{$t('recortar')}}</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="detailsDialog" width="500" scrollable>
                <v-card v-if="selectedOcrFile">
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>Datos del Documento</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="detailsDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text style="max-height: 400px;">
                        <v-alert :value="true" type="info" outline class="caption mb-3 pa-2">
                             Puede editar los datos si la detección automática fue incorrecta.
                        </v-alert>

                        <div v-if="selectedOcrFile.validations && selectedOcrFile.validations.specific_rules" class="mb-3">
                            <h4 class="mb-2 grey--text text--darken-2 body-2 font-weight-bold">Validaciones Adicionales</h4>
                            <v-layout row wrap>
                                <v-flex shrink v-for="(val, key) in selectedOcrFile.validations.specific_rules" :key="key">
                                    <v-chip 
                                       small 
                                       :color="val ? 'success' : 'error'" 
                                       text-color="white" 
                                       class="mr-2 mb-1"
                                    >
                                       <v-icon left small>{{ val ? 'check' : 'close' }}</v-icon>
                                       {{ formatFieldName(key) }}: {{ val ? 'Correcto' : 'Incorrecto' }}
                                    </v-chip>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-2"></v-divider>
                        </div>

                        <!-- Datos Editables -->
                        <div v-if="selectedOcrFile.ocrData">
                            <v-layout row wrap>
                                <v-flex xs12 v-for="(value, key) in selectedOcrFile.ocrData" :key="key">
                                    <v-text-field
                                        v-if="typeof value === 'boolean'"
                                        :value="formatFieldValue(value)"
                                        :label="formatFieldName(key)"
                                        outline
                                        hide-details
                                        class="mb-2"
                                        readonly
                                        append-icon="lock"
                                    ></v-text-field>

                                    <v-text-field
                                        v-else
                                        v-model="selectedOcrFile.ocrData[key]"
                                        :label="formatFieldName(key)"
                                        outline
                                        hide-details
                                        class="mb-2"
                                        :readonly="!isFieldEditable(key)"
                                        :append-icon="!isFieldEditable(key) ? 'lock' : 'edit'"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div v-else class="text-xs-center grey--text my-4">
                             No hay datos extraídos disponibles para editar.
                        </div>

                        <v-divider class="my-3"></v-divider>
                        
                         <div v-if="selectedOcrFile.validations">
                             <h4 class="mb-2 grey--text text--darken-2">Validación de Vigencia</h4>
                             
                             <v-chip 
                                :color="selectedOcrFile.validations.is_current ? 'success' : 'error'"
                                text-color="white"
                                class="mb-3"
                             >
                                <v-icon left>{{ selectedOcrFile.validations.is_current ? 'check_circle' : 'warning' }}</v-icon>
                                {{ selectedOcrFile.validations.is_current ? 'Documento Vigente' : 'Documento Vencido' }}
                             </v-chip>

                             <v-text-field
                                v-if="selectedOcrFile.validations.valid_until !== undefined"
                                v-model="selectedOcrFile.validations.valid_until"
                                label="Válido hasta"
                                prepend-icon="event"
                                readonly
                                outline
                                hint="Dato extraído automáticamente"
                                persistent-hint
                             ></v-text-field>
                         </div>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" flat @click="detailsDialog = false">Cancelar</v-btn>
                        <v-btn color="primary" @click="saveOcrDetails()">Guardar Cambios</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="faceComparisonDialog" width="500" persistent>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>Validación de Rostro</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="faceComparisonDialog = false" :disabled="faceComparisonLoading">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pt-4">
                        <div v-if="faceModalState === 'loading'" class="text-xs-center">
                            <v-progress-circular indeterminate color="primary" size="60" class="mb-4"></v-progress-circular>
                            <p class="headline mb-4">Analizando fotos...</p>
                            <v-alert :value="true" type="info" outline class="mb-4">
                                Mientras procesamos, recuerda que la validación funciona mejor con:
                            </v-alert>
                            <div class="text-xs-left">
                                <p><strong>✓ Iluminación:</strong> Buena iluminación uniforme sin sombras fuertes</p>
                                <p><strong>✓ Ángulo:</strong> Tu rostro de frente a la cámara, cabeza recta</p>
                                <p><strong>✓ Calidad:</strong> Imágenes claras y bien enfocadas, no borrosas</p>
                                <p><strong>✓ Documento:</strong> INE claro y legible, completamente visible</p>
                            </div>
                        </div>
                        <div v-else-if="faceModalState === 'error'">
                            <v-alert :value="true" type="error" outline class="mb-4">
                                <strong>Error en la validación:</strong><br>
                                {{faceComparisonError}}
                            </v-alert>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Entendido
                            </v-btn>
                        </div>
                        <div v-else-if="faceModalState === 'success'">
                            <v-alert :value="true" type="success" outline class="mb-4">
                                <v-icon color="success" class="mr-2">check_circle</v-icon>
                                <strong>¡Validación Exitosa!</strong>
                            </v-alert>
                            <v-card class="mb-4">
                                <v-card-text>
                                    <p><strong>Confianza:</strong> {{ faceComparisonResult.confidence.toFixed(1) }}%</p>
                                    <p><strong>Nivel:</strong> {{ faceComparisonResult.confidence_text }}</p>
                                    <p><strong>Calidad INE:</strong> {{ faceComparisonResult.id_face_quality.toFixed(1) }}%</p>
                                    <p><strong>Calidad Selfie:</strong> {{ faceComparisonResult.profile_face_quality.toFixed(1) }}%</p>
                                </v-card-text>
                            </v-card>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Continuar
                            </v-btn>
                        </div>
                        <div v-else-if="faceModalState === 'no-match'">
                            <v-alert :value="true" type="warning" outline class="mb-4">
                                <v-icon color="warning" class="mr-2">warning</v-icon>
                                <strong>Las fotos no coinciden</strong>
                            </v-alert>
                            <p class="mb-4">Las imágenes no parecen ser de la misma persona. Por favor:</p>
                            <ul class="mb-4">
                                <li>Verifica que la foto del INE sea clara y legible</li>
                                <li>Toma un nuevo selfie de frente con buena iluminación</li>
                                <li>Asegúrate de que tu rostro sea claramente visible en ambas fotos</li>
                            </ul>
                            <v-btn color="primary" @click="faceComparisonDialog = false" block>
                                Intentar de Nuevo
                            </v-btn>
                        </div>
                        <div v-else class="text-xs-center">
                            <p class="grey--text">Iniciando...</p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('preregistro')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="mt-4">
                            <v-layout row wrap justify-center class="mb-3">
                                <v-flex xs12 class="text-xs-center" v-if="dataUser.length > 0">
                                    <img 
                                        :src="dataUser[0].logo" 
                                        style="max-height: 200px; max-width: 100%; object-fit: contain;"
                                    />
                                </v-flex>
                                <v-flex xs12 class="text-xs-center">
                                    <div class="caption grey--text font-italic">Powered by Intrare</div>
                                </v-flex>
                            </v-layout>
                            <v-form class="mb-4" ref="formulario">
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="first_name"
                                                prepend-icon="person"
                                                name="first_name"
                                                :label="$t('Nombre')"
                                                :error-messages="errores.first_name"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 >
                                        <v-text-field
                                                v-model="last_name"
                                                prepend-icon="person_outline"
                                                name="last_name"
                                                :label="$t('Apellido')"
                                                :error-messages="errores.last_name"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="email"
                                                prepend-icon="email"
                                                name="email"
                                                label="E-Mail"
                                                :error-messages="errores.email"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <vue-phone-number-input
                                                default-country-code="MX"
                                                color="#D32F2F"
                                                valid-color="#2196F3"
                                                @update="onChange"
                                                v-model="celular"
                                                :translations="custom_cell_phone"
                                        >
                                        </vue-phone-number-input>
<!--                                        <v-alert-->
<!--                                                :value="!band_cellphone"-->
<!--                                                type="error"-->
<!--                                                outline-->
<!--                                                transition="scale-transition"-->
<!--                                        >-->
<!--                                            {{errores.celular}}-->
<!--                                        </v-alert>-->
<!--                                        <v-text-field-->
<!--                                                v-model="celular"-->
<!--                                                prepend-icon="phone_iphone"-->
<!--                                                name="celular"-->
<!--                                                mask="phone"-->
<!--                                                placeholder="(000) 000 - 0000"-->
<!--                                                :label="$t('celular')"-->
<!--                                                :error-messages="errores.celular"-->
<!--                                        >-->
<!--                                        </v-text-field>-->
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-layout row wrap class="text-xs-center" v-if="dataUser.length > 0">
                                    <v-flex class="ingla pt-3 pb-3 pl-3 pr-3" xs12 sm6>
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                :src="resultIneFrenteURL"
                                                v-if="resultIneFrenteURL"
                                                width="auto"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores.ine_frente"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores.ine_frente}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneFrenteURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        {{$t('msg_fotos')}}
                                    </v-flex>
                                    <v-flex class="ingla pt-3 pb-3 pl-3 pr-3" xs12 sm6 v-if="dataUser[0].idCompany !== 17">
                                        <v-label>
                                            {{$t('foto_ine')}}<br>[{{$t('reverso')}}]
                                        </v-label>
                                        <br>
                                        <v-img
                                                :src="resultIneAtrasURL"
                                                v-if="resultIneAtrasURL"
                                                width="auto"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores.ine_atras"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores.ine_atras}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog3 = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageIneAtrasURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        {{$t('msg_fotos')}}
                                    </v-flex>
                                    <v-flex class="ingla pt-3 pb-3 pl-3 pr-3" xs12 sm6 v-if="dataUser[0].idCompany !== 17">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <v-img
                                                :src="resultFotoFrenteURL"
                                                v-if="resultFotoFrenteURL"
                                                width="auto"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <br>
                                        <v-alert
                                                :value="errores.avatar"
                                                type="error"
                                                outline
                                                transition="scale-transition"
                                        >
                                            {{errores.avatar}}
                                        </v-alert>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog2 = true, degrees = 0, ratio = 1"
                                                    accept="image/*"
                                                    v-model="imageFotoFrenteURL"
                                            >{{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        {{$t('msg_fotos')}}
                                    </v-flex>
                                    <v-flex xs12 class="mt-3 mb-3" v-if="dataUser[0] && dataUser[0].idCompany !== 17">
                                        <v-btn
                                            :disabled="!resultIneFrenteURL || !resultFotoFrenteURL"
                                            color="primary"
                                            @click="openFaceComparisonModal()"
                                            block
                                        >
                                            Validar Rostro
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 class="mt-3 mb-2">
                                        <v-card outlined class="pa-4 mb-4" v-if="documentationOptions.length > 0">
                                            <v-card-title Primary-title>
                                                <h3 class="headline mb-0">Documentación Requerida</h3>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-container grid-list-lg fluid class="pa-0">
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md4 v-for="(archivo, index) in archivos" :key="index">

                                                            <input 
                                                                type="file" 
                                                                :ref="'fileInput' + index" 
                                                                style="display: none" 
                                                                :accept="acceptedFileTypes"
                                                                @change="onFileChange($event, index)" 
                                                            />

                                                            <!-- DOCUMENT CARD -->
                                                            <v-card height="100%" class="d-flex flex-column" :class="{
                                                              'dashed-border': !archivo,
                                                              'elevation-2': archivo && !archivo.error,
                                                              'elevation-0': !archivo,
                                                              'grey lighten-4': !archivo,
                                                              'red lighten-5': archivo && archivo.error
                                                            }" style="cursor: pointer; position: relative; min-height: 200px;"
                                                              @click="!archivo || archivo.error ? triggerFileInput(index) : null">

                                                              <div v-if="!archivo" class="fill-height layout column align-center justify-center pa-4 text-xs-center">
                                                                <v-icon large color="grey darken-1" class="mb-3">cloud_upload</v-icon>
                                                                <div class="subheading grey--text text--darken-2 font-weight-bold mb-1">{{ documentationOptions[index].name }}</div>
                                                                <div class="caption grey--text">Click para subir archivo</div>
                                                              </div>

                                                              <div v-else-if="archivo.loading"
                                                                class="fill-height layout column align-center justify-center pa-4 text-xs-center">
                                                                <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
                                                                <div class="body-1 blue--text text--darken-2 font-weight-bold">{{ documentationOptions[index].name }}</div>
                                                                <div class="caption grey--text mt-1">Analizando documento...</div>
                                                              </div>

                                                              <div v-else class="fill-height layout column align-center justify-center pa-3 text-xs-center" style="width: 100%">

                                                                <div v-if="archivo.error || (archivo.validations && archivo.validations.is_current === false)" style="width: 100%">
                                                                  <v-icon large color="error" class="mb-2">error_outline</v-icon>
                                                                  <div class="subheading font-weight-bold mb-1 ml-1 mr-1 text-truncate">{{ documentationOptions[index].name }}</div>

                                                                  <v-alert :value="true" type="error" outline class="caption pa-1 mb-2">
                                                                    <div v-if="archivo.error">{{ archivo.error }}</div>
                                                                    <div v-if="archivo.validations && archivo.validations.is_current === false">Documento vencido</div>
                                                                  </v-alert>

                                                                  <v-btn small outline color="error" @click.stop="triggerFileInput(index)">
                                                                    <v-icon left small>refresh</v-icon> Reintentar
                                                                  </v-btn>
                                                                  <v-btn v-if="archivo.ocrData" small flat color="error" @click.stop="openOcrDetails(archivo)">
                                                                    <v-icon left small>visibility</v-icon> Ver/Corregir
                                                                  </v-btn>
                                                                </div>

                                                                <div v-else style="width: 100%">
                                                                  <v-icon large color="success" class="mb-2">check_circle</v-icon>
                                                                  <div class="subheading font-weight-bold mb-1 text-truncate">{{ documentationOptions[index].name }}</div>
                                                                  <div class="green--text font-weight-bold caption mb-2">Validado correctamente</div>
                                                                  <div class="grey--text caption mb-3">{{ humanFileSize(archivo.file.size) }}</div>

                                                                  <v-layout row justify-center>
                                                                    <v-btn v-if="!archivo.ocrSkipped" small flat color="primary" @click.stop="openOcrDetails(archivo)">
                                                                      <v-icon left small>visibility</v-icon> Ver/Corregir
                                                                    </v-btn>
                                                                    <v-btn small icon flat color="grey" @click.stop="triggerFileInput(index)">
                                                                      <v-icon small>edit</v-icon>
                                                                    </v-btn>
                                                                  </v-layout>
                                                                </div>
                                                              </div>
                                                            </v-card>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 align="justify">
                                        <small>Para poder continuar con el Proceso de Preregistro es necesario
                                            <strong>Aceptar</strong> nuestros <strong>Términos y Condiciones</strong>,
                                            los cuales puede consultar dando click en la siguiente liga:
                                            <a @click="dialog_condiciones = true">Términos y Condiciones</a>.
                                        </small>
                                        <v-checkbox
                                                v-model="checkbox_aceptar"
                                                label="Aceptar Términos y Condiciones"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value="errores && errores.length > 0"
                                        type="error"
                                        outline
                                        class="mb-3"
                                >
                                    <div v-for="(error, index) in errores" :key="index" class="mb-1">
                                        {{ error }}
                                    </div>
                                </v-alert>
                                <v-alert
                                        :value="alerta"
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                                <v-btn
                                        color="primary"
                                        @click="preregistro()"
                                        :loading="loading"
                                        block
                                >
                                    {{$t('enviar')}}
                                </v-btn>
                                <br>
                                {{$t('msg_preregistro')}}
                                <br>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { mapState } from 'vuex'
    import VuejsClipper from 'vuejs-clipper'

    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)

    Vue.use(VuejsClipper ,{
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })
    const FALLBACK_OCR_TYPES = [
      {
        "type_id": "curp",
        "name": "CURP",
        "description": "Constancia de la Clave Única de Registro de Población",
        "fields": ["curp", "nombre", "fecha_inscripcion", "folio", "entidad"]
      },
      {
        "type_id": "rfc",
        "name": "RFC / Constancia de Situación Fiscal",
        "description": "Constancia de Situación Fiscal emitida por el SAT",
        "fields": ["RFC", "razon_social", "nombre_comercial", "regimen_capital", "fecha_inicio", "estatus", "regimen_fiscal", "codigo_postal"]
      },
      {
        "type_id": "dc3",
        "name": "DC-3",
        "description": "Constancia de Competencias o Habilidades Laborales",
        "fields": ["nombre_trabajador", "curp_trabajador", "ocupacion", "puesto", "nombre_empresa", "rfc_empresa", "nombre_curso", "duracion_horas", "fecha_inicio", "fecha_fin", "area_tematica", "agente_capacitador"]
      },
      {
        "type_id": "opinion_cumplimiento",
        "name": "Opinión de Cumplimiento",
        "description": "Opinión del cumplimiento de obligaciones fiscales (32-D)",
        "fields": ["RFC", "razon_social", "sentido", "folio", "fecha_emision", "vigente"]
      },
      {
        "type_id": "cedula_sua",
        "name": "Cédula SUA",
        "description": "Cédula de Determinación de Cuotas del Sistema Único de Autodeterminación",
        "fields": ["registro_patronal", "RFC", "razon_social", "actividad", "bimestre", "fecha_proceso", "delegacion_imss", "subdelegacion_imss", "total_cotizantes", "total_rcv", "total_infonavit"]
      },
      {
        "type_id": "linea_captura_imss",
        "name": "Línea de Captura IMSS",
        "description": "Formato para pago de cuotas obrero patronales del IMSS",
        "fields": ["registro_patronal", "RFC", "razon_social", "delegacion", "subdelegacion", "periodo_imss", "bimestre_rcv", "fecha_limite", "total_pagar", "linea_captura", "folio_sua", "num_cotizantes"]
      }
    ];

    export default {
        name: "preregistro",
        data () {
            return{
                alerta: false,
                first_name: '',
                last_name: '',
                celular:'',
                email: '',
                errores: [],
                loading: false,
                dialog: false,
                dialog2: false,
                dialog3: false,
                dialog_condiciones: false,
                resultIneFrenteURL: '',
                resultIneAtrasURL: '',
                resultFotoFrenteURL: '',
                imageIneFrenteURL: '',
                imageIneAtrasURL: '',
                imageFotoFrenteURL: '',
                checkbox_aceptar: false,
                dialog_aceptar: false,
                dialog_bloqueo: false,
                dialog_cellphone: false,
                custom_cell_phone: { },
                band_cellphone: false,
                cellphone_plus_country_code: '',
                degrees: 0,
                ratio: 1,
                valid: true,
                files: {
                    dc3: null,
                    imss: null,
                    curp: null,
                    rfc: null,
                    licencia: null,
                },
                fileRule: (value) => !!value || 'Archivo requerido',
                // Validaciones para los documentos
                dataUser: [],
                numArchivos: 0, // cantidad inicial
                archivos: [],   // arreglo con objetos { file, error }
                maxFileSize: 2 * 1024 * 1024, // 2MB
                acceptedFileTypes: '.pdf,image/*', // Tipos de archivo permitidos
                documentationOptions: [], // Tipos de documentación desde la API
                avatar: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAADAklEQVRo3u2ZzWuTQRDGf01txRgt9uMgtTdREUoDausHHiw9edeq9SIiHtSrVr1brzWtWvwTxJNf4OfFk+hJEdGTNVhoFBRLSSskHnZfKDHvZmd334RiHphDks0zM7uzs7Oz0EQT/zdaAvG0AoPAIWAXsAPYDGT07wvAN+Aj8BZ4CbwGSo2egD7gOpAHykL5CkwAvY0wvAeYAZYcDK+UJeAm0FUv408APwIYXikF4GiShrcBdxIwvFKmgTWhjU8Dj+pgfCT3gXUhZ15ifBGYBIaA9VqGgBv6N4kTQVZCEjZ5YMDAlUWWsaZ9jR8TzvyABWdWuBLOG7sHWbaZFHDnBLwFHFPsjEBJGXUS22KvkFscSluQH1IZAX9GyF0k5sROxSg4D7RLvRZAWoOtBc7ZDm7FrbZJMoTKwCxVJrzaCgziVmCdFIwdc+DvA3bbDLziMDtRnGYt+LO4F4HjNg7ccySPDjKTE1ncwjOSuzYOvPdQUNazm0PFeUbLPv2db/n9zsaBJErlUFKoNLbaJpbk83pjg40DqwrVytUFoNOTt4S6xP/SnztQqdm3ifDbxoE5BweWgSfAc+AV8AFYrBiTBnYCB4ERLdLTfs5mkCSNfkGVHS4r1glcQJ2wQdPoZQuiP3pciHqpHbiqOWvpvWRDWKtOWQaGAxheiRHNbdK9x4YohWo6xZFcTMD4COOYw9U6a04YiJJsQHUb9F6TEJkuNKcSdOB0jM7YC40Jt2LIFlG1TWjs19zVdOZcCLuB7zGEP7XCUDigOavpmsfjYD1GfEwWgTOehrcAZzG3WY74zs5tA3kZeAr0O/D2A89qcE/5Gg+qtfiwhqISqv14HNho4OpAdbcf6/+YOK1ai7bFVRp1jB+2GFsCPgOfUHENsAnYBmzFLpc/AEb5t57yQhvxmSmkTNnMvA9GUTej0IbPE2DD2qIL1e6TNGlN2SyH/x3ECb2oskNSEkcyiyoPvB75Qj2zplBNp2HUM+t2bdjKZ9Y8amO/AV6gnlsb/szaRBOrHX8BTX7HyUOjY8oAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDItMTVUMDA6MzU6MDErMDA6MDByOxknAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAyLTE1VDAwOjM1OjAxKzAwOjAwA2ahmwAAAABJRU5ErkJggg==',
                // OCR Variables
                detailsDialog: false,
                selectedOcrFile: null,
                ocrSupportedTypes: [],
                menuDate: false,
                // Facial recognition
                faceComparisonLoading: false,
                faceComparisonResult: null,
                faceComparisonError: null,
                faceComparisonDialog: false,
            }
        },
        created: async function (){
            await this.get_info_new_guest()
            this.fetchOcrTypes()
        },
        beforeUpdate() {
            this.custom_cell_phone ={
                "countrySelectorLabel": this.$t('codigo_pais'),
                "phoneNumberLabel": this.$t('celular'),
                "example": this.$t('ejemplo')
            }
        },
        computed: {
            ...mapState(['language']),
            faceModalState() {
                if (this.faceComparisonLoading) return 'loading';
                if (this.faceComparisonError) return 'error';
                if (this.faceComparisonResult) {
                    if (this.faceComparisonResult.success && this.faceComparisonResult.match) return 'success';
                    return 'no-match';
                }
                return 'idle';
            },
            puedeSubir() {
                if (this.documentationOptions.length === 0) {
                    return true // No se requieren archivos
                }
                return this.archivos.length && this.archivos.every(a => 
                    a && 
                    !a.loading && 
                    !a.error && 
                    (!a.validations || a.validations.is_current !== false)
                )
            }
        },
        methods:{
            async subirArchivos() {
                const formData = new FormData()
                formData.append('user_id', this.dataUser[0].id)

                this.archivos.forEach((file, index) => {
                    if (file) {
                    formData.append('files', file.file)
                    formData.append('documentation_ids', this.documentationOptions[index].id)
                    }
                });
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/upload-documents-by-user/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language,
                    },
                    data: formData
                };
                
                const validationResults = [];
                this.archivos.forEach((archivo, index) => {
                    if (archivo && archivo.file) {
                        const validationResult = {
                            success: !archivo.error && !archivo.ocrSkipped,
                            validations: archivo.validations || {},
                            valid_until: (archivo.validations && archivo.validations.valid_until) || null,
                            ocr_confidence: (archivo.validations && archivo.validations.ocr_confidence) || null,
                            errors: archivo.error ? [archivo.error] : [],
                            extracted_data: archivo.ocrData || {}
                        };
                        validationResults.push(JSON.stringify(validationResult));
                    }
                });
                
                 validationResults.forEach(result => {
                    formData.append('validation_results', result);
                });

                axios(config)
                    .then(ok => {
                        this.loading = false
                        console.log("Preregistro exitoso.")
                        this.$router.push({path: '/registro/exito'})
                    })
                    .catch(error => {
                        this.errores = [];
                        if (error.response) {
                            if (error.response.status == 400) {
                                this.errores = ['Algunos documentos no cumplieron con los requisitos de validación.'];
                            } else if (error.response.status == 500) {
                                this.errores = ['Error del servidor al procesar los documentos. Por favor intenta más tarde.'];
                            } else {
                                this.errores = ['Error al subir documentos: ' + (error.response.statusText || 'Error desconocido')];
                            }
                        } else if (error.message) {
                            this.errores = ['Error de conexión al subir documentos: ' + error.message];
                        } else {
                            this.errores = ['Error desconocido al procesar los documentos. Por favor intenta nuevamente.'];
                        }
                        console.error("Error al subir archivos:", error)
                    })
                    .finally(() => (this.loading = false))
            },
            async fetchDocumentationTypes() {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-all-documents-by-user-by-invitation/{idUser}/'.replace('{idUser}', this.dataUser[0].id),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                .then(result => {
                    this.documentationOptions = result.data
                    this.numArchivos = result.data.length
                    const nuevoArr = []
                    for (let i = 0; i < this.documentationOptions.length; i++) {
                    nuevoArr.push( null)
                    }
                    this.archivos = nuevoArr
                    console.log(this.documentationOptions)
                    console.log('Valor de archivos = ', this.archivos)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            onFileChange(e, index) {
                const file = e.target.files[0];
                const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'].includes(file.type)

                if (!file) {
                    this.$set(this.archivos, index, null);
                    return;
                }

                let error = null;
                if (file.size > this.maxFileSize) {
                    error = `El archivo supera los ${this.humanFileSize(this.maxFileSize)}`;
                } else if (!isValidType) {
                    error = "El archivo debe ser PDF o imagen (JPEG/PNG).";
                }
                this.$set(this.archivos, index, { file, error });
            },
            humanFileSize(size) {
                if (size === 0) return "0 B";
                const i = Math.floor(Math.log(size) / Math.log(1024));
                const sizes = ["B", "KB", "MB", "GB"];
                return (size / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
            },
            clear: function () {
                this.$store.commit('snackbar_activate_false')
            },
            onChange (data) {
                console.log(data)
                this.cellphone_plus_country_code = data.e164
                // console.log(data.formattedNumber)
                // console.log(data.isValid)
                this.band_cellphone = data.isValid
                // Object.assign(this, {
                //   nationalNumber,
                //   countryCode: data.countryCode
                // })
            },
            validarFormularioCompleto() {
                const erroresValidacion = [];

                // Validar términos y condiciones
                if (!this.checkbox_aceptar) {
                    erroresValidacion.push('✓ Debes aceptar los Términos y Condiciones');
                }

                // Validar teléfono
                if (!this.band_cellphone) {
                    erroresValidacion.push('✓ Teléfono inválido o incompleto');
                }

                // Validar nombre
                if (!this.first_name || this.first_name.trim() === '') {
                    erroresValidacion.push('✓ El nombre es requerido');
                }

                // Validar apellido
                if (!this.last_name || this.last_name.trim() === '') {
                    erroresValidacion.push('✓ El apellido es requerido');
                }

                // Validar email
                if (!this.email || this.email.trim() === '') {
                    erroresValidacion.push('✓ El correo electrónico es requerido');
                }

                // Validar fotos INE y Selfie
                if (!this.resultIneFrenteURL || this.resultIneFrenteURL.length <= 6) {
                    erroresValidacion.push('✓ Foto del INE (frente) es requerida');
                }

                if (this.dataUser[0] && this.dataUser[0].idCompany !== 17) {
                    if (!this.resultFotoFrenteURL || this.resultFotoFrenteURL.length <= 6) {
                        erroresValidacion.push('✓ Foto de perfil (selfie) es requerida');
                    }

                    if (!this.resultIneAtrasURL || this.resultIneAtrasURL.length <= 6) {
                        erroresValidacion.push('✓ Foto del INE (reverso) es requerida');
                    }

                    // Validación facial obligatoria
                    if (!this.faceComparisonResult || !this.faceComparisonResult.success || !this.faceComparisonResult.match) {
                        erroresValidacion.push('✓ Debes validar tu rostro con la foto del INE (presiona el botón "Validar Rostro")');
                    }
                }

                return erroresValidacion;
            },

            preregistro: function() {
                this.loading = true
                this.errores = []
                // Realizar todas las validaciones
                const erroresValidacion = this.validarFormularioCompleto();

                if (erroresValidacion.length > 0) {
                    this.errores = ['Faltan datos por completar:'].concat(erroresValidacion);
                    this.loading = false
                    return
                }

                // Proceder con el envío sin VeeValidate
                var bodyFormData = new FormData()
                var file = null
                var file2 = null
                var file3 = null
                bodyFormData.set('first_name', this.first_name)
                bodyFormData.set('last_name', this.last_name)
                bodyFormData.set('celular', this.cellphone_plus_country_code)
                bodyFormData.set('email', this.email)
                bodyFormData.set('username', this.email)
                bodyFormData.set('temporalToken', '')
                bodyFormData.set('is_active', true)
                if (this.resultIneFrenteURL != '' && this.resultIneFrenteURL.length > 6) {
                    file = this.dataURLtoFile(this.resultIneFrenteURL, 'picture.jpeg')
                }
                bodyFormData.append('ine_frente', file)
                if (this.dataUser[0].idCompany !== 17) {
                    if (this.resultIneAtrasURL != '' && this.resultIneAtrasURL.length > 6) {
                        file3 = this.dataURLtoFile(this.resultIneAtrasURL, 'picture2.jpeg')
                    }
                    bodyFormData.append('ine_atras', file3)
                } else {
                    bodyFormData.append('ine_atras', file)
                }
                if (this.dataUser[0].idCompany === 17) {
                    this.resultFotoFrenteURL = this.avatar
                }
                if (this.resultFotoFrenteURL != '' && this.resultFotoFrenteURL.length > 6) {
                    file2 = this.dataURLtoFile(this.resultFotoFrenteURL, 'avatar.jpeg')
                }
                bodyFormData.append('avatar', file2)
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/partialUpdateUser/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language,
                    },
                    data: bodyFormData
                };
                console.log("Enviando datos al servidor...");
                axios(config)
                    .then(ok => {
                        console.log("Respuesta exitosa del servidor");
                        if (this.archivos.length > 0) {
                            this.subirArchivos()
                        }
                        else{
                            this.loading = false
                            console.log("Preregistro exitoso.")
                            this.$router.push({path: '/registro/exito'})
                        }
                    })
                    .catch(error => {
                        console.error("Error del servidor:", error);
                        this.errores = [];
                        if (error.response) {
                            if (error.response.status == 400 && typeof error.response.data == "object" && error.response.data) {
                                if (Array.isArray(error.response.data)) {
                                    this.errores = error.response.data;
                                } else if (typeof error.response.data === 'object') {
                                    this.errores = ['Error en los datos: ' + JSON.stringify(error.response.data)];
                                }
                            } else if (error.response.status == 404) {
                                this.errores = ['Token inválido o expirado. Por favor, solicita un nuevo enlace de registro.'];
                            } else if (error.response.status == 500) {
                                this.errores = ['Error del servidor. Por favor intenta más tarde.'];
                            } else {
                                this.errores = ['Error al procesar tu registro: ' + (error.response.statusText || 'Error desconocido')];
                            }
                        } else if (error.message) {
                            this.errores = ['Error de conexión: ' + error.message];
                        } else {
                            this.errores = ['Error desconocido al procesar el registro. Por favor intenta nuevamente.'];
                        }
                    })
                    .finally(() => (this.loading = false));
            },
            get_info_new_guest: async function () {
                // console.log('GET INFO NEW GUEST')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getUser/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(ok => {
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        } else {
                            this.dataUser = ok.data
                            console.log('Data User = ', this.dataUser[0].id)
                            this.fetchDocumentationTypes()
                        }
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            get_image_recortada: function () {
                const canvas = this.$refs.clipper.clip();//call component's clip method
                this.resultIneFrenteURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
            },
            get_image_recortada2: function () {
                const canvas = this.$refs.clipper2.clip();//call component's clip method
                this.resultFotoFrenteURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
            },
            get_image_recortada3: function () {
                const canvas = this.$refs.clipper3.clip();//call component's clip method
                this.resultIneAtrasURL = canvas.toDataURL("image/jpeg", 0.2);//canvas->image
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            async fetchOcrTypes() {
              try {
                const response = await axios.get('https://microservices.intrare.app/ocr/document/types/');
                if (response.data && Array.isArray(response.data)) {
                  this.ocrSupportedTypes = response.data;
                } else if (response.data && Array.isArray(response.data.types)) {
                  this.ocrSupportedTypes = response.data.types;
                } else {
                  console.warn('Unexpected OCR types format, using fallback.', response.data);
                  this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
                }
              } catch (e) {
                console.error("Error fetching OCR types, using fallback.", e);
                this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
              }
            },
            formatFieldName(key) {
              if (!key) return '';
              if (this.$te(key)) return this.$t(key);
              return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            },
            formatFieldValue(value) {
              if (typeof value === 'boolean') {
                return value ? 'Correcto' : 'Incorrecto';
              }
              return value;
            },
            isFieldEditable(key) {
                return true; 
            },
            openOcrDetails(archivo) {
              this.selectedOcrFile = archivo;
              this.detailsDialog = true;
            },
            triggerFileInput(index) {
              this.$refs['fileInput' + index][0].click();
            },
            saveOcrDetails() {
                this.detailsDialog = false;
                this.$forceUpdate(); // Forzar render si es necesario
            },
            files_validations(archivo){
                if(archivo && archivo.validations && archivo.validations.is_current === false){
                    return false
                }
                return true
            },
            async onFileChange(e, index) {
                const file = e.target.files[0];
                const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'].includes(file.type)

                if (!file) {
                    this.$set(this.archivos, index, null);
                    return;
                }

                let error = null;
                if (file.size > this.maxFileSize) {
                    error = `El archivo supera los ${this.humanFileSize(this.maxFileSize)}`;
                } else if (!isValidType) {
                    error = "El archivo debe ser PDF o imagen (JPEG/PNG).";
                }
                
                if (error) {
                    this.$set(this.archivos, index, { file, error, loading: false });
                    return;
                }

                // Iniciar carga local
                this.$set(this.archivos, index, { file, error: null, loading: true });

                // Inicia validación OCR
                try {
                    const docName = this.documentationOptions[index].name.toLowerCase();
                    let docType = null;

                    console.log('Validando documento:', docName);

                    if (this.ocrSupportedTypes && this.ocrSupportedTypes.length > 0) {
                      const match = this.ocrSupportedTypes.find(type => {
                        const typeValue = typeof type === 'string' ? type : (type.type_id || type.type || '');
                        const val = typeValue.toLowerCase();
                        if (docName.includes(val)) return true;
                        if (docName.includes(val.replace(/_/g, ' '))) return true;
                        if (val === 'cedula_sua' && docName.includes('sua')) return true;
                        if (val === 'linea_captura_imss' && (docName.includes('linea') || docName.includes('captura'))) return true;
                        if (val === 'opinion_cumplimiento' && docName.includes('opinion')) return true;
                        if (val === 'dc3' && docName.replace(/-/g, '').includes('dc3')) return true; // Handle DC-3
                        return false;
                      });

                      if (match) {
                        docType = typeof match === 'string' ? match : (match.type_id || match.type);
                      }
                    }

                    if (!docType) {
                      console.log(`Documento '${docName}' no soportado por OCR o no match. Saltando validación.`);
                      this.$set(this.archivos, index, {
                        file,
                        error: null,
                        loading: false,
                        ocrSkipped: true
                      });
                      return;
                    }

                    const formData = new FormData();
                    formData.append('document', file);
                    formData.append('document_type', docType);

                    const response = await axios.post('https://microservices.intrare.app/ocr/document/', formData, {
                      headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-api-key': '63f6f7729962518de2073625d1e61be17d5f99b5',
                      }
                    });

                    const ocrResult = response.data;
                    let fileError = null;

                    if (!ocrResult.validations) {
                        ocrResult.validations = {};
                    }

                    const validUntilStr = ocrResult.validations.valid_until || ocrResult.valid_until;

                    if (validUntilStr) {
                        const validUntil = new Date(validUntilStr);
                        const today = new Date();
                        today.setHours(0,0,0,0);
                        
                        if (!isNaN(validUntil.getTime())) {
                            // Asignar al objeto validations para compatibilidad
                            ocrResult.validations.valid_until = validUntilStr;
                            ocrResult.validations.is_current = validUntil >= today;
                        }
                    } else {
                        // Si no hay fecha explicita de validez, y success es true, asumimos valido
                        if (ocrResult.success && ocrResult.validations.is_current === null) {
                             ocrResult.validations.is_current = true;
                        }
                    }

                    if (!ocrResult.success) {
                      fileError = ocrResult.errors ? ocrResult.errors.join(', ') : 'No se pudo validar el documento.';
                    }

                    this.$set(this.archivos, index, {
                      file,
                      error: fileError,
                      loading: false,
                      ocrData: ocrResult.extracted_data,
                      validations: {
                        ...ocrResult.validations,
                        is_valid: ocrResult.success,
                        is_current: ocrResult.validations && ocrResult.validations.is_current,
                        valid_until: ocrResult.valid_until,
                        ocr_confidence: ocrResult.ocr_confidence
                      }
                    });
                } catch (err) {
                    console.error('OCR Error', err);
                    this.$set(this.archivos, index, { file, error: "Error al conectar con el servicio de validación.", loading: false });
                }
            },
            openFaceComparisonModal() {
                this.faceComparisonLoading = true;
                this.faceComparisonError = null;
                this.faceComparisonResult = null;
                this.faceComparisonDialog = true;
                this.compareFacialRecognition();
            },
            async compareFacialRecognition() {
                this.faceComparisonError = null;
                this.faceComparisonLoading = true;
                this.faceComparisonResult = null;

                try {
                    // Validar que ambas imágenes estén disponibles
                    if (!this.resultIneFrenteURL) {
                        this.faceComparisonError = 'Por favor, sube la foto del INE (frente)';
                        this.faceComparisonLoading = false;
                        return;
                    }

                    if (!this.resultFotoFrenteURL) {
                        this.faceComparisonError = 'Por favor, sube la foto de perfil (selfie)';
                        this.faceComparisonLoading = false;
                        return;
                    }

                    // Convertir las imágenes base64 a Blob
                    const ineBlob = this.dataURLtoBlob(this.resultIneFrenteURL);
                    const fotoBlob = this.dataURLtoBlob(this.resultFotoFrenteURL);

                    console.log('INE Blob size:', ineBlob.size, 'type:', ineBlob.type);
                    console.log('Foto Blob size:', fotoBlob.size, 'type:', fotoBlob.type);

                    // Crear FormData
                    const formData = new FormData();
                    formData.append('id_image', ineBlob, 'ine.jpg');
                    formData.append('profile_image', fotoBlob, 'selfie.jpg');

                    // Realizar la comparación
                    const response = await axios.post(
                        'https://microservices.intrare.app/identification/compare/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'X-API-Key': '63f6f7729962518de2073625d1e61be17d5f99b5',
                            }
                        }
                    );

                    this.faceComparisonResult = response.data;
                    this.faceComparisonLoading = false;

                    if (!response.data.success) {
                        this.faceComparisonError = response.data.message || 'Error en la comparación facial';
                    }
                } catch (err) {
                    this.faceComparisonLoading = false;
                    console.error('Facial Recognition Error', err);
                    if (err.response && err.response.data) {
                        console.log('Response Data:', err.response.data);
                    }

                    let errorMessage = 'Error al conectar con el servicio';

                    if (err.response && err.response.data) {
                        const data = err.response.data;
                        // Intentar extraer el mensaje de varias posibles ubicaciones
                        if (data.message) {
                            errorMessage = data.message;
                        } else if (data.error) {
                            errorMessage = typeof data.error === 'string' ? data.error : data.error.message || 'Error desconocido';
                        } else if (data.detail) {
                            errorMessage = data.detail;
                        } else if (typeof data === 'string') {
                            errorMessage = data;
                        }
                    } else if (err.message) {
                        errorMessage = err.message;
                    }

                    this.faceComparisonError = errorMessage;
                }
            },
            dataURLtoBlob(dataURL) {
                const arr = dataURL.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
        }
    }
</script>


<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    .ingla {
        border-radius: 2px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 2px 2px 2px 2px;
        border-style: solid solid solid solid;
    }
    .dashed-border {
        border: 2px dashed #9e9e9e !important;
        border-radius: 8px !important;
    }
</style>
